import script from "./SplitShadesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitShadesDialog.vue?vue&type=script&setup=true&lang=js"

import "./SplitShadesDialog.vue?vue&type=style&index=0&id=3c187d4e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c187d4e"]])

export default __exports__